import React from "react";
import styled from "@emotion/styled";

import mediaqueries from "@styles/media";

import {Icon} from '@types';

const Logo: Icon = ({fill = "white"}) => {
    return (
        <LogoContainer>
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                 width="140pt" height="35pt" viewBox="0 0 1709.000000 429.000000"
                 preserveAspectRatio="xMidYMid meet">

                <g transform="translate(0.000000,429.000000) scale(0.100000,-0.100000)"
                   fill="#000000" stroke="none">
                    <path d="M1135 3399 c-3 -8 -4 -489 -3 -1069 l3 -1055 378 -3 377 -2 0 1009
c0 940 1 1011 17 1027 15 15 35 16 178 11 246 -9 352 -33 495 -110 87 -46 107
-61 174 -125 65 -62 118 -142 147 -222 21 -58 24 -81 24 -215 0 -163 -9 -202
-67 -319 -35 -70 -179 -219 -252 -261 -112 -65 -167 -78 -339 -81 -172 -2
-207 -10 -207 -50 0 -47 32 -60 132 -55 62 4 74 -10 130 -145 78 -185 157
-309 240 -377 24 -20 80 -53 123 -74 77 -37 84 -38 185 -38 119 0 167 14 176
51 11 42 -13 58 -71 48 -105 -17 -186 -11 -247 19 -71 35 -178 147 -231 243
-51 91 -109 239 -105 267 2 17 20 28 88 53 153 55 243 109 330 196 159 160
242 401 212 615 -38 265 -180 450 -439 570 -80 37 -152 56 -293 79 -136 22
-1147 33 -1155 13z" fill={fill} />
                    <path d="M9605 3401 l-40 -6 0 -305 0 -305 65 0 65 0 0 310 0 310 -25 1 c-14
1 -43 -1 -65 -5z" fill={fill} />
                    <path d="M13218 3209 c-17 -9 -18 -59 -18 -809 0 -568 3 -807 11 -827 26 -64
32 -71 63 -76 17 -3 72 -12 121 -21 50 -9 96 -18 104 -19 11 -1 18 18 26 76
13 91 15 88 -85 111 -34 8 -65 18 -69 21 -3 4 -8 354 -11 778 l-5 772 -60 2
c-33 2 -68 -2 -77 -8z" fill={fill} />
                    <path d="M11800 3201 l-25 -7 -3 -877 c-2 -829 -1 -878 15 -885 30 -12 452 -8
550 6 248 33 455 119 555 230 161 178 147 483 -30 647 -75 70 -272 139 -427
150 -44 4 -102 11 -128 17 l-48 10 68 48 c106 75 156 175 157 315 2 188 -110
292 -372 344 -59 12 -272 13 -312 2z m329 -147 c84 -19 155 -63 183 -114 16
-28 19 -49 15 -110 -6 -106 -41 -165 -137 -228 -70 -47 -160 -79 -246 -88
l-60 -6 -12 138 c-11 128 -26 376 -24 399 2 28 174 33 281 9z m259 -730 c175
-33 276 -77 365 -163 79 -75 91 -100 91 -187 -1 -59 -5 -80 -27 -116 -32 -56
-111 -132 -174 -169 -77 -46 -223 -88 -353 -100 -136 -14 -347 -6 -366 13 -15
15 -28 155 -45 480 -10 181 -10 230 0 242 24 29 356 29 509 0z" fill={fill} />
                    <path d="M4040 2894 c-199 -25 -372 -100 -494 -214 -146 -138 -217 -272 -252
-480 -17 -105 -17 -182 1 -280 21 -116 30 -143 76 -238 36 -72 59 -103 139
-182 76 -76 114 -104 185 -141 177 -92 271 -114 485 -114 173 0 215 6 350 52
124 43 269 137 319 209 27 39 28 90 1 104 -28 15 -50 1 -146 -91 -148 -141
-308 -197 -534 -186 -63 3 -130 11 -147 17 l-33 12 0 328 c0 290 2 329 16 334
9 3 231 6 494 6 372 0 481 3 487 13 13 20 4 226 -13 291 -54 215 -207 397
-414 494 -80 37 -118 47 -247 67 -118 17 -131 17 -273 -1z m358 -112 l22 -13
0 -319 0 -320 -210 0 -210 0 0 329 c0 305 1 330 18 335 37 10 357 1 380 -12z" fill={fill} />
                    <path d="M6532 2894 c-159 -29 -281 -90 -409 -206 -29 -26 -58 -48 -63 -48
-14 0 -20 34 -23 140 l-2 95 -315 0 -315 0 0 -800 0 -800 315 0 315 0 3 593
c2 467 5 598 15 612 38 55 116 135 170 176 95 71 147 94 215 94 101 0 92 75
94 -750 l3 -725 315 0 315 0 0 625 c0 576 -1 630 -18 684 -57 185 -170 277
-379 311 -114 18 -137 18 -236 -1z" fill={fill} />
                    <path d="M8295 2895 c-110 -15 -160 -28 -248 -66 -304 -129 -488 -412 -487
-752 1 -491 356 -837 859 -837 306 0 553 124 717 361 128 183 171 470 109 714
-37 144 -142 307 -260 402 -125 100 -260 155 -438 178 -126 17 -130 17 -252 0z
m310 -100 c240 -47 453 -236 532 -471 25 -73 27 -91 27 -249 0 -158 -2 -176
-27 -250 -15 -44 -40 -104 -57 -133 -70 -121 -238 -264 -368 -312 -107 -40
-296 -63 -332 -40 -13 8 -15 102 -18 726 -3 831 -12 760 98 751 36 -3 101 -13
145 -22z" fill={fill} />
                    <path d="M14030 2573 c-177 -62 -274 -181 -325 -401 -20 -83 -19 -254 1 -345
18 -81 67 -190 114 -255 38 -52 133 -116 205 -137 29 -8 86 -15 127 -15 287 1
469 225 468 579 -1 168 -35 302 -104 404 -48 72 -136 137 -220 161 -52 15
-231 21 -266 9z m213 -160 c52 -14 72 -27 123 -78 84 -83 106 -150 108 -325 1
-109 -2 -133 -22 -184 -59 -152 -175 -246 -304 -246 -65 0 -107 19 -169 77
-88 82 -133 186 -144 329 -18 222 66 379 227 425 80 23 104 23 181 2z" fill={fill} />
                    <path d="M10244 2530 c-87 -28 -125 -57 -156 -119 -39 -77 -39 -174 0 -246 51
-93 214 -173 422 -205 97 -16 129 -29 172 -74 83 -86 44 -210 -86 -267 -43
-19 -68 -23 -156 -23 -124 1 -231 26 -327 79 l-62 34 -26 -69 c-15 -38 -24
-78 -21 -88 8 -25 93 -66 191 -91 99 -26 309 -29 400 -6 127 33 218 95 259
177 22 44 26 65 26 143 0 77 -4 99 -25 141 -14 27 -39 64 -57 81 -38 37 -147
93 -179 93 -13 0 -36 4 -53 9 -17 5 -69 19 -116 32 -109 28 -169 58 -209 105
-26 29 -31 42 -26 63 8 31 40 68 76 86 60 32 219 27 354 -10 100 -28 98 -28
112 40 13 67 12 72 -25 86 -135 52 -370 66 -488 29z" fill={fill} />
                    <path d="M15215 2501 c-190 -56 -334 -170 -412 -329 l-38 -77 0 -140 c0 -138
1 -141 33 -206 38 -79 82 -121 170 -162 62 -29 66 -29 185 -24 78 3 138 11
167 22 70 26 155 74 200 112 23 20 44 32 48 28 4 -3 12 -104 18 -223 l11 -217
-66 -62 -66 -63 -350 -2 -350 -3 0 -85 0 -85 399 -3 400 -2 39 37 c22 21 61
64 88 96 l49 58 0 553 c0 631 2 613 -81 696 -70 70 -135 93 -274 96 -82 2
-125 -2 -170 -15z m237 -150 c51 -22 91 -62 112 -113 23 -53 20 -153 -5 -207
-85 -188 -326 -330 -504 -297 -87 17 -151 122 -143 234 12 161 178 333 373
387 71 19 117 18 167 -4z" fill={fill} />
                </g>
            </svg>
        </LogoContainer>
    );
};

export default Logo;

const LogoContainer = styled.div`
  .Logo__Mobile {
    display: none;
  }

  ${mediaqueries.tablet`
    .Logo__Desktop {
      display: none;
    }
    
    .Logo__Mobile{
      display: block;
    }
  `}
`;